import NextLink from "next/link";
import type SharedLinkProps from "../SharedLinkProps";
import getParsedHref from "./getParsedHref";
import patchHrefLocale from "./helpers/patchHrefLocale";

const BridgeSiteLink: FC<SharedLinkProps> = (props) => {
  const { href, isExternal } = getParsedHref(props);

  const clonedProps: Partial<SharedLinkProps> = { ...props };
  delete clonedProps.isBridgeSite;
  delete clonedProps.defaultLang;
  delete clonedProps.language;
  delete clonedProps.domain;

  if (isExternal) {
    return (
      <a
        className={props.className}
        href={href.toString()}
        target={props.target}
      >
        {props.children}
      </a>
    );
  }
  return (
    <NextLink {...clonedProps} href={patchHrefLocale({ ...props, href })} />
  );
};

export default BridgeSiteLink;
